import { APP_BASE_HREF } from '@angular/common';
import {
  Component,
  Inject,
  OnInit,
  HostListener,
  VERSION,
  DOCUMENT
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { InitialServices } from './_services/initial.services';
import { PrimeLocaleService } from './prime-locale.service';
import { BusyService } from './shared/services/busy.service';
import { environment } from '../environments/environment'; /* Not used */

@Component({
  // Keep feedback above legacy employee overlays, which use z-index 999999.
  template: `<p-toast position="top-right" [baseZIndex]="1000000" [breakpoints]="{ '767px': { width: 'calc(100vw - 2rem)', right: '1rem' } }"></p-toast><kuba-busy [busy]="(busy$ | async) === true" message="PROCESSING"></kuba-busy><router-outlet></router-outlet>`,
  standalone: false
})
export class AppComponent implements OnInit {
  /** Drives the one global progress bar for every write the user starts. */
  readonly busy$: Observable<boolean>;

  constructor(
    public translate: TranslateService /* Not used */,
    @Inject(DOCUMENT) private document: Document,
    @Inject(APP_BASE_HREF) private baseHref: string,
    private initialServices: InitialServices,
    private router: Router,
    private primeLocale: PrimeLocaleService,
    private busyService: BusyService
  ) {
    this.busy$ = this.busyService.busy$;
  }

  ngOnInit() {
    const pathname = this.document.location.pathname;
    // Anonymous chemicals pages: the single shared safety data sheet, and the QR code's
    // read-only chemical list. Both are reached by people with no Kuba account, so neither
    // may be bounced to /login by this bootstrap redirect.
    const isPublicSdsPage =
      pathname.indexOf('safety-data-sheets/share/') > -1 ||
      pathname.indexOf('safety-data-sheets/public/') > -1;
    // The employee answering a work environment survey follows an invitation
    // link and has no Kuba session; without this they are bounced to /login.
    const isPublicSurveyRespondent =
      pathname.indexOf('work-environment-survey/respondent/') > -1;
    // The anonymous deviation form opened from a QR code; the reporter has no Kuba account.
    const isPublicDeviationQrForm = pathname.indexOf('deviation/qr/') > -1;
    const isAuthenticationPage = /\/(?:login|forget-password)\/?$/.test(pathname);
    if (
      !isAuthenticationPage &&
      pathname != '/youtube.com' &&
      !(pathname.indexOf('reset-password') > -1) &&
      !(pathname.indexOf('image-uploader') > -1) &&
      !isPublicSdsPage &&
      !isPublicSurveyRespondent &&
      !isPublicDeviationQrForm
    ) {
      if (!(window.name === 'Remote' || window.name === 'FAQ')) {
        this.router.navigate(['/login']);
      }
    }
    this.initialServices.appInitializing();
  }
}
